import { ICategory } from 'interfaces';
import { useSelect } from "@refinedev/antd";
import { dataProvider } from '../../provider/dataProvider';
import { api } from '../../utils/api';
import { useEffect, useMemo, useState } from 'react';

const dp = dataProvider(api);

const useDictionarySelectProps = () => {
    const { selectProps: applicantProps } = useSelect<ICategory>({
        resource: 'dictionary/applicants',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: "server"
        }
    });

    const { selectProps: procedureProps } = useSelect<ICategory>({
        resource: 'dictionary/preliminary_request_procedure',
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        pagination: {
            mode: "server"
        }
    });

    const { selectProps: statusProps } = useSelect<ICategory>({
        resource: 'dictionary/preliminary_request_state',
        optionLabel: 'name',
        optionValue: 'id',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: "server"
        }
    });

    const { selectProps: manufacturerProps } = useSelect<ICategory>({
        resource: 'dictionary/manufacturers',
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        pagination: {
            mode: "server"
        }
    });

    return { applicantProps, procedureProps, statusProps, manufacturerProps };
};

const useInnSelectProps = (id?: number) => {
    const [initialOption, setInitialOption] = useState<any>(null);

    const {
        selectProps: { options, ...selectRest },
    } = useSelect({
        resource: 'dictionary/international-names',
        optionLabel: 'name',
        optionValue: 'id',
        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        pagination: {
            mode: "server"
        }
    });

    useEffect(() => {
        if (!id) return;

        dp.getOne({
            resource: 'dictionary/international-names',
            id,
        })
            .then(({ data }) => {
                setInitialOption({
                    label: data.name,
                    value: data.id,
                });
            })
            .catch(err => {
                console.error('getOne error', err);
            });
    }, [id]);

    const mergedOptions = useMemo(() => {
        if (initialOption) {
            return [initialOption, ...(options || [])].filter(
                (opt, idx, arr) =>
                    arr.findIndex(o => o.value === opt.value) === idx
            );
        }
        return options;
    }, [options, initialOption]);

    return {
        selectProps: {
            showSearch: true,
            allowClear: true,
            labelInValue: true,
            options: mergedOptions,
            ...selectRest,
        },
    };
};

export { useInnSelectProps, useDictionarySelectProps };
